import React from 'react';
import '../../../Components/common/Modal/modal.css';
import './RuntimeConfigPanel.css';

const getEntryLabel = (target) => {
  if (!target) {
    return '';
  }
  if (target.extension) {
    return target.extension;
  }
  if (target.prefix) {
    return target.prefix;
  }
  return target.pattern || '';
};

const RemoveConfirmModal = ({ target, submitting = false, onConfirm, onCancel }) => {
  if (!target) {
    return null;
  }

  const entryLabel = getEntryLabel(target);

  return (
    <div
      className="bulk-upload-soft-delete-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="runtime-config-remove-title"
      data-testid="remove-confirm-modal"
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div
        className="bulk-upload-soft-delete-dialog bulk-upload-filename-space-dialog runtime-config-remove-dialog"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="instructions delete-folder-modal-main bulk-upload-filename-space-body runtime-config-remove-modal-main">
          <div className="delete-folder-modal-copy-delete">
            <p
              className="delete-folder-note bulk-upload-filename-space-note runtime-config-remove-message"
              id="runtime-config-remove-title"
            >
              <strong>
                Are you sure you want to remove this entry from the runtime configuration?
              </strong>
            </p>
            <p className="delete-folder-path runtime-config-remove-entry">
              <strong className="delete-folder-path-text">{entryLabel}</strong>
            </p>
          </div>
          <div className="delete-folder-actions">
            <input
              type="button"
              className="unzip-formButton"
              value="Cancel"
              onClick={onCancel}
              disabled={submitting}
              data-testid="cancel-remove-btn"
            />
            <input
              type="button"
              className="unzip-formButtonGo"
              value={submitting ? 'Removing…' : 'Remove'}
              onClick={onConfirm}
              disabled={submitting}
              data-testid="confirm-remove-btn"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveConfirmModal;
